import Image1 from "../asset/Images/sapm.png";
import Image2 from "../asset/Images/wheels.png";
import Image3 from "../asset/Images/todo.png";
import Image4 from "../asset/Images/styleH.png";
import Image5 from "../asset/Images/plaH.png";
import Image6 from "../asset/Images/spcsH.png";
import Image7 from "../asset/Images/insta.png";
import Image8 from "../asset/Images/portfolio.png";
import Image9 from "../asset/Images/bgClub.png"
import Image10 from "../asset/Images/mvhub.png";
import Image11 from "../asset/Images/imgEdt.png";
const ProjectData =[
    {
        img:Image11,
        link:"https://810gec.csb.app/",
        title:"Image Editor",
        description:"Edit unsplash Images and download it as SVG"
    },
    {
        img:Image10,
        link:"https://rehan-flix.vercel.app/",
        title:"RehanFlix",
        description:"Netflix movies details website"
    },
    {
        img:Image9,
        link:"https://github.com/RehanAli357/BloggersClub",
        title:"BloggersClub ",
        description:"Blogging website where you can write blogs and read others blog"
    },
    {
        img:Image1,
        link:"https://github.com/RehanAli357/DSAVisualizer",
        title:"DSA Visualizer",
        description:"Helps to understand the DSA topics in a visualize form"
    },
    {
        img:Image2,
        link:"https://github.com/RehanAli357/WheelsOnTravel",
        title:"Wheels On Travel",
        description:"Admin Page which stores Companys Data and helps to perform CRUD operation"
    },
    {
        img:Image3,
        link:"https://github.com/RehanAli357/FireBaseToDoList",
        title:"To Do List",
        description:"React FireBase ToDo List helps to store day to day task "
    },
    {
        img:Image8,
        link:"https://github.com/RehanAli357/Portfolio",
        title:"Porfolio",
        description:"My Portfolio website here user can see my work and can contact me"

    },
    {
        img:Image4,
        link:"https://github.com/RehanAli357/StylePicker",
        title:"Style Picker",
        description:"Helps to design website by simply copy pasting the code "
    },
    {
        img:Image7,
        link:"https://github.com/RehanAli357/instagramClone",
        title:"Instagram Clone",
        description:"This is the Instagram Clone using ReactJs"
    },
    {
        img:Image5,
        link:"https://github.com/RehanAli357/PlayStationClone",
        title:"PlayStation Clone",
        description:"This is the PlayStation Clone"
    },
    {
        img:Image6,
        link:"#",
        title:"SpaceX Clone",
        description:"This is the SpaceX Clone"
    }
]

export default ProjectData;